import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "notification-container",
  "aria-live": "polite",
  "aria-label": "Notification center"
}
const _hoisted_2 = ["aria-live"]
const _hoisted_3 = { class: "notification__icon" }
const _hoisted_4 = {
  key: 0,
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}
const _hoisted_5 = {
  key: 1,
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}
const _hoisted_6 = {
  key: 2,
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}
const _hoisted_7 = {
  key: 3,
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}
const _hoisted_8 = { class: "notification__content" }
const _hoisted_9 = { class: "notification__message" }
const _hoisted_10 = ["onClick"]

import { useNotifications } from '../services/notifications.service';


export default /*@__PURE__*/_defineComponent({
  __name: 'AppNotifications',
  setup(__props) {

const { notifications, removeNotification } = useNotifications();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_unref(notifications).length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_TransitionGroup, {
            name: "notification",
            tag: "div",
            class: "notifications-wrapper"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(notifications), (notification) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: notification.id,
                  class: _normalizeClass([
            'notification',
            `notification--${notification.type}`
          ]),
                  role: "alert",
                  "aria-live": notification.type === 'error' ? 'assertive' : 'polite'
                }, [
                  _createElementVNode("div", _hoisted_3, [
                    (notification.type === 'success')
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_4, _cache[0] || (_cache[0] = [
                          _createElementVNode("path", {
                            "fill-rule": "evenodd",
                            d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
                            "clip-rule": "evenodd"
                          }, null, -1)
                        ])))
                      : (notification.type === 'error')
                        ? (_openBlock(), _createElementBlock("svg", _hoisted_5, _cache[1] || (_cache[1] = [
                            _createElementVNode("path", {
                              "fill-rule": "evenodd",
                              d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z",
                              "clip-rule": "evenodd"
                            }, null, -1)
                          ])))
                        : (notification.type === 'warning')
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_6, _cache[2] || (_cache[2] = [
                              _createElementVNode("path", {
                                "fill-rule": "evenodd",
                                d: "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z",
                                "clip-rule": "evenodd"
                              }, null, -1)
                            ])))
                          : (_openBlock(), _createElementBlock("svg", _hoisted_7, _cache[3] || (_cache[3] = [
                              _createElementVNode("path", {
                                "fill-rule": "evenodd",
                                d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
                                "clip-rule": "evenodd"
                              }, null, -1)
                            ])))
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("p", _hoisted_9, _toDisplayString(notification.message), 1)
                  ]),
                  _createElementVNode("button", {
                    onClick: ($event: any) => (_unref(removeNotification)(notification.id)),
                    class: "notification__close",
                    type: "button",
                    "aria-label": "Close notification"
                  }, _cache[4] || (_cache[4] = [
                    _createElementVNode("svg", {
                      width: "16",
                      height: "16",
                      viewBox: "0 0 20 20",
                      fill: "currentColor"
                    }, [
                      _createElementVNode("path", {
                        "fill-rule": "evenodd",
                        d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                        "clip-rule": "evenodd"
                      })
                    ], -1)
                  ]), 8, _hoisted_10)
                ], 10, _hoisted_2))
              }), 128))
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})